var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdateOraGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "75px",
    viewBox: "0 0 88 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 2.000000)",
    stroke: "#B6B6B6",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1862521,63.708234 L5.30104837,47.7353059 C-1.76701612,40.6282085 -1.76701612,29.1053274 5.30104837,21.9982303 C5.39180051,21.906977 5.4835154,21.8166969 5.57617749,21.7274053 L22.8732488,5.05950403 C29.9817427,-1.79042279 41.2318699,-1.67009327 48.1938452,5.33032899 L67.0545867,24.2952268 C72.709038,29.9809043 72.709038,39.1992096 67.0545867,44.8848871 L58.5729091,53.4134039 C52.9184578,59.0990814 43.7507801,59.0990814 38.0963287,53.4134039 L32.0455988,47.3292594 L32.0455988,47.3292594",
    id: "Path-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8908269,71 L18.0056232,55.0270718 C10.9375587,47.9199745 10.9375587,36.3970933 18.0056232,29.2899963 C18.0963753,29.1987429 18.1880902,29.1084627 18.2807523,29.0191714 L35.5778235,12.35127 C42.6863175,5.50134319 53.9364447,5.62167271 60.89842,12.622095 L79.7591615,31.5869928 C85.4136128,37.2726703 85.4136128,46.4909756 79.7591615,52.1766531 L71.2774839,60.7051699 C65.6230326,66.3908474 56.4553549,66.3908474 50.8009035,60.7051699 L44.7501736,54.6210254 L44.7501736,54.6210254",
    id: "Path-4",
    transform: "translate(48.352287, 39.145883) rotate(180.000000) translate(-48.352287, -39.145883) "
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 44,
    cy: 37,
    r: 8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateOraGray);
export default __webpack_public_path__ + "static/media/update_ora_gray.31e6848a4118f2cbb4e63cff9b46fed7.svg";
export { ForwardRef as ReactComponent };